export const PAUSE_DEFLECTION_WEEKS = [2, 3]
export const PAUSE_DEFLECTION_REASON = 'Deflection modal ignored'

export const PAUSE_PLAN_TARGET_MEAL_QTY = 6

export function getPauseDeflectionChangePlanTitle({ planMealsQty }) {
  if (planMealsQty > PAUSE_PLAN_TARGET_MEAL_QTY) {
    return 'pauseDeflection.changePlan.downgrade_plan_title'
  }
  return 'pauseDeflection.changePlan.title'
}
